const REFERRAL_CODE_KEY = "referralCode";

export function setReferralCodeInCookie(code: string): void {
    // Set cookie with 30 days expiration
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${REFERRAL_CODE_KEY}=${encodeURIComponent(code)}; ${expires}; path=/`;
}

export function getReferralCodeFromCookie(): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + REFERRAL_CODE_KEY + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export function getReferralCodeFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('ref');
}

export function processReferralCode(): string | null {
    // First check URL for referral code
    const codeFromUrl = getReferralCodeFromUrl();
    
    if (codeFromUrl) {
        // Save to cookie for future use
        setReferralCodeInCookie(codeFromUrl);
        return codeFromUrl;
    }
    
    // Otherwise check if we have it in cookie
    return getReferralCodeFromCookie();
}

export function clearReferralCode(): void {
    // Clear cookie by setting it with past expiration date
    document.cookie = `${REFERRAL_CODE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}